import { render, staticRenderFns } from "./RequiresOnboarding.vue?vue&type=template&id=79ce19c0"
import script from "./RequiresOnboarding.vue?vue&type=script&lang=js"
export * from "./RequiresOnboarding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports